import { FlashIcon, InfoBanner, RightArrowIcon } from "@codat/orchard-ui";
import React from "react";
import styles from "./ConnectionErrorBanner.module.scss";

interface ConnectionErrorBannerProps {
  companyId: string;
}

export const ConnectionErrorBanner: React.FC<ConnectionErrorBannerProps> = (
  props
) => {
  const { companyId } = props;

  return (
    <InfoBanner
      data-testid="connection-error-banner"
      className={styles.connectionError}
      title="There's a problem with a connection"
      subtitle="You may see issues with pulling data due to an active issue with a
            data connection."
      color="warning"
      icon={<FlashIcon />}
      buttons={[
        {
          variant: "secondary",
          color: "interface",
          to: `/companies/${companyId}/connections`,
          children: (
            <div>
              <span style={{ marginRight: "0.5rem" }}>See More</span>
              <RightArrowIcon />
            </div>
          ),
        },
      ]}
    />
  );
};
